import { render, staticRenderFns } from "./PostRow.vue?vue&type=template&id=64027908&scoped=true"
import script from "./PostRow.vue?vue&type=script&lang=ts"
export * from "./PostRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64027908",
  null
  
)

export default component.exports